export enum ServiceOrderChannel {
  CREATE = 'serviceOrder::create',
  EDIT = 'serviceOrder::patch',
  DELETE = 'serviceOrder::delete',
}
